import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'

import Home from '../views/Home.vue'
import Contact from '../views/Contact.vue'
import Blog from '../views/Blog.vue'
import BlogPost from '../views/BlogPost.vue'
import Catalog from '../views/Catalog.vue'
import WineInfo from '../views/WineInfo.vue'
import Food from '../views/Food.vue'
import Login from '../views/Login.vue'
import AdminPanel from '../components/AdminPanel.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes:  [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home-page',
      component: Home
    },
    {
      path: '/hafa-samband',
      name: 'contact-page',
      component: Contact
    },
    {
      path: '/blog',
      name: 'blog-page',
      component: Blog
    },
    {
      /* path: '/blog/:post */
      path: '/blog/:postID',
      props: true,
      name: 'blog-post',
      component: BlogPost
    },
    {
      path: '/vin',
      props: true,
      name: 'catalog-page',
      component: Catalog
    },
    {
      /* path: '/vin/:item', */
      path: '/vin/:wineID',
      props: true,
      name: 'wine-info-page',
      component: WineInfo
    },
    {
      path: '/vin-med-mat',
      name: 'food-page',
      component: Food
    },
    {
			path: '/login',
			name: 'Login',
			component: Login
		},
    {
      path: '/admin-panel',
      name: 'admin-panel',
      component: AdminPanel,
      meta: {
        requiresAuth: true
      }
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
      next('/login')
  } else if (requiresAuth && currentUser) {
      next()
  } else {
      next()
  }
})
  
export default router
